import styled from 'styled-components';
import { color } from 'styles/pallete';

export const photo = styled.div<{ $image: string }>`
	position: relative;
	min-width: 100px;
	min-height: 100px;
	background-image: url(${(props) => props.$image});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	border-radius: 50%;
	cursor: pointer;
`;

export const hoverDiv = styled.div`
	cursor: pointer;
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: ${color.interface.darkgray3};
	opacity: 0.8;
	border-radius: 50%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	> p {
		font-size: 1.2rem;
		color: ${color.interface.white};
	}

	> svg {
		width: 20px;
		height: 20px;
		color: ${color.interface.white};
	}
`;

export const inputFile = styled.input`
	position: absolute;
	display: none;
	width: 100%;
	height: 100%;
	z-index: 500;
	cursor: pointer;
`;

export const errorFile = styled.p`
	font-size: 1rem;
	color: ${color.interface.red} !important;
`;
